/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// Replace with lodash/noop
// oxlint-disable-next-line no-empty-function
export const noop = (): void => {};
